import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";
import "../styles/index.scss";
import "bootstrap";
import "jquery-validation";
import "./ui.js";
import "animate.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "aos/dist/aos.js";

import "nodecloud-particleground/jquery.particleground.js";
//import "nodecloud-particleground/demo/js/demo.js";

class Main {
  constructor() {
    this.onDOMLoaded();
    this.onDocumentLoad();
    this.onResize();
    window.jQuery = $;
    window.$ = $;
  }

  onDocumentLoad() {
    window.addEventListener("load", (event) => {
      /*STICKY HEADER JS*/
      // $(window).scroll(function () {
      // 	var sticky = $("#header"),
      // 		scroll = $(window).scrollTop();
      // 	if (scroll >= 35) {
      // 		sticky.addClass("scrolled-header");
      // 	} else {
      // 		sticky.removeClass("scrolled-header");
      // 	}
      // });
      // if ($(".site_default_banner").length < 1) {
      // 	$("body").addClass("banner-inactive");
      // } else {
      // 	$("body").removeClass('transparent-header').addClass("banner-active");
      // }

      $(".blogs-featured-listing-slider").owlCarousel({
        loop: true,
        margin: 0,
        responsiveClass: true,
        nav: false,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
            loop: false,
          },
        },
      });
    });
  }

  onDOMLoaded() {
    document.addEventListener("DOMContentLoaded", (event) => {
      var owl = $("#owl-banner-section").owlCarousel({
        responsiveClass: true,
        lazyLoad: false,
        loop: true,
        rewind: true,
        dots: true,
        items: 1,
        autoplay: false,
        autoplayTimeout: 6000,
        autoHeight: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          1000: {
            items: 1,
          },
        },
      });
      owl.on("changed.owl.carousel", function (event) {
        owl.trigger("stop.owl.autoplay");
        owl.trigger("play.owl.autoplay", [6000]);
      });
      // Handle initialized event
      owl.on("initialized.owl.carousel", function (event) {
        var currentItem = event.item.index;
        updateDataAndBullets(currentItem);
      });

      // Handle changed event
      owl.on("changed.owl.carousel", function (event) {
        owl.trigger("stop.owl.autoplay");
        owl.trigger("play.owl.autoplay", [6000]);
        var currentItem = event.item.index;
        updateDataAndBullets(currentItem);
      });

      function updateDataAndBullets(index) {
        var $currentItem = $("#owl-banner-section .owl-item")
          .eq(index)
          .find(".item");
        var videoUrl = $currentItem.data("video-url");
        var videoImage = $currentItem.data("video-image");
        var videoTitle = $currentItem.data("video-title");
        var videoPara = $currentItem.data("video-para");

        // Update play_video_icon <a> href attribute
        $(".play_video_icon a").attr("href", videoUrl);

        // Update play_video_icon <img> src attribute
        $(".play_video_icon img").attr("src", videoImage);

        // Update content_box <h4> and <p> elements
        $(".home-slider-video .content_box h4").text(videoTitle);
        $(".home-slider-video .content_box p").text(videoPara);
      }

      // Trigger Owl Carousel initialization
      owl.trigger("initialize.owl.carousel");

      /* VIDEO SLIDER */
      var homeowl = $("#home_slider_block");
      homeowl.owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        dots: false,
        dotsData: true,
        autoHeight: true,
        dotsContainer: ".owl-dots",
      });
      /*for new home page slider*/
      var newhomeslider = $("#new_home_slider_block").owlCarousel({
        responsiveClass: true,
        lazyLoad: false,
        loop: true,
        nav: true,
        margin: 80,
        dots: true,
        items: 2,
        autoplay: false,
        autoplayTimeout: 6000,
        stagePadding: 300,
        autoHeight: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 2,
          },
        },
      });
      /*for new business page feature slider*/
      var newbusinessslider = $("#businessIntroList_featM").owlCarousel({
        //responsiveClass: true,
        lazyLoad: false,
        loop: true,
        nav: false,
        dots: true,
        items: 1.5,
        touchDrag: true,
        mouseDrag: true,
        autoplay: false,
        autoplayTimeout: 6000
      });

      /*for new business page popup box slider*/
      var newbusinessslider = $(".business_popupSlider").owlCarousel({
        // responsiveClass: true,
        lazyLoad: false,
        loop: true,
        nav: false,
        dots: true,
        items: 1.2,
        touchDrag: true,
        mouseDrag: true,
        autoplay: false,
        autoplayTimeout: 6000        
      });

      // trust block slider
      var trustBlock = $(".site_featured_list0_img").owlCarousel({
        responsiveClass: true,
        lazyLoad: false,
        loop: true,
        nav: true,
        //rewind: true,
        margin: 24,
        dots: true,
        items: 3,
        autoplay: true,
        autoplayTimeout: 6000,
        autoHeight: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
          },
        },
      });

      homeowl.on("changed.owl.carousel", function (event) {
        var current = event.item.index;
        $("#owl-dots-custom").find(".custom-owl-dot").removeClass("dot-active");
        $("#owl-dots-custom")
          .find(".owl-dot-" + current)
          .addClass("dot-active");
        if ($(".play-icon-slider").hasClass("play-icon-hide")) {
          $(".play-icon-slider").removeClass("play-icon-hide");
        }
        $(".sliderVideo").each(function () {
          var vi_id = $(this).attr("id");
          document.getElementById(vi_id).pause();
        });
      });

      $(".next-owl-slide").click(function () {
        homeowl.trigger("next.owl.carousel");
      });
      $(".prev-owl-slide").click(function () {
        homeowl.trigger("prev.owl.carousel");
      });

      var age_assurance1 = $(".tab-slider-1");
      age_assurance1.owlCarousel({
        items: 1,
        loop: false,
        nav: true,
        dots: false,
        dotsData: true,
        autoHeight: true,
        dotsContainer: ".owl-dots",
      });

      age_assurance1.on("changed.owl.carousel", function (event) {
        var current = event.item.index;
        $(".tab-slider-1")
          .parents(".inner_custom_row")
          .find(".custom-owl-dot")
          .removeClass("dot-active");
        $(".tab-slider-1")
          .parents(".inner_custom_row")
          .find(".owl-dot-" + current)
          .addClass("dot-active");
        if ($(".play-icon-slider").hasClass("play-icon-hide")) {
          $(".play-icon-slider").removeClass("play-icon-hide");
        }
        $(".sliderVideo").each(function () {
          var vi_id = $(this).attr("id");
          document.getElementById(vi_id).pause();
        });
      });

      $(".next-slide-1").click(function () {
        age_assurance1.trigger("next.owl.carousel");
      });
      $(".prev-slide-1").click(function () {
        age_assurance1.trigger("prev.owl.carousel");
      });

      var age_assurance2 = $(".tab-slider-2");
      age_assurance2.owlCarousel({
        items: 1,
        loop: false,
        nav: true,
        dots: false,
        dotsData: true,
        autoHeight: true,
        dotsContainer: ".owl-dots",
      });

      age_assurance2.on("changed.owl.carousel", function (event) {
        var current = event.item.index;
        $(".tab-slider-2")
          .parents(".inner_custom_row")
          .find(".custom-owl-dot")
          .removeClass("dot-active");
        $(".tab-slider-2")
          .parents(".inner_custom_row")
          .find(".owl-dot-" + current)
          .addClass("dot-active");
        if ($(".play-icon-slider").hasClass("play-icon-hide")) {
          $(".play-icon-slider").removeClass("play-icon-hide");
        }
        $(".sliderVideo").each(function () {
          var vi_id = $(this).attr("id");
          document.getElementById(vi_id).pause();
        });
      });

      $(".next-slide-2").click(function () {
        age_assurance2.trigger("next.owl.carousel");
      });
      $(".prev-slide-2").click(function () {
        age_assurance2.trigger("prev.owl.carousel");
      });

      jQuery(".sliderVideo").click(function () {
        if (this.paused) {
          this.play();
          $(".play-icon-slider").addClass("play-icon-hide");
        } else {
          this.pause();
          $(".play-icon-slider").removeClass("play-icon-hide");
        }
      });

      jQuery(".play-icon-slider-img").click(function () {
        $(this).parents(".play-icon-slider").addClass("play-icon-hide");
        var videoid = $(this)
          .parents(".video-wrapper")
          .find("video")
          .attr("id");
        document.getElementById(videoid).play();
        document
          .getElementById(videoid)
          .addEventListener("ended", videoEndHandler, false);
      });

      function videoEndHandler(e) {
        $(".play-icon-slider").removeClass("play-icon-hide");
      }

      /* VIDEO SLIDER */

      // header menu dropdown js
      jQuery("ul.primary-menu li.menu-item-has-children>a").click(function () {
        jQuery(this)
          .children(".siteHeader .custom-mega-menu li ul.sub-menu")
          .stop(true, true)
          .slideToggle("fast"),
          jQuery(this).toggleClass("sub-dropdown-active");
      });
      // end header menu dropdown js

      jQuery(".get_stated_btn").on("click", function (e) {
        e.preventDefault();
        let hash = $(this).attr("href");
        var top_val = 70;
        if (hash != "#") {
          $("html, body").animate(
            {
              scrollTop: $(hash).offset().top - top_val, // 100 for sticky header
            },
            250,
            "linear"
          );
        }
      });

      var v = $("#contact-form-about-you-7").validate({
        rules: {
          first_name: {
            required: true,
          },
          last_name: {
            required: true,
          },
          email: {
            required: true,
            email: true,
          },
          business_name: {
            required: true,
          },
          your_query: {
            required: true,
          },
          "agree_luciditi_policy[]": {
            "agree_luciditi_policy[]": true,
          },
        },
        messages: {
          first_name: "Enter your First Name",
          last_name: "Enter your Last Name",
          email: "Enter your Email",
          business_name: "Enter your Business Name",
          your_query: "Enter Your Query",
          "agree_luciditi_policy[]": "",
        },
      });

      var valid = $("#contact-form-request-demo-7").validate({
        rules: {
          first_name: {
            required: true,
          },
          last_name: {
            required: true,
          },
          business_name: {
            required: true,
          },
          business_email: {
            required: true,
            email: true,
          },
          telephone: {
            required: true,
          },
          "agree_luciditi_policy[]": {
            "agree_luciditi_policy[]": true,
          },
        },
        messages: {
          first_name: "Enter your First Name",
          last_name: "Enter your Last Name",
          business_name: "Enter your Business Name",
          business_email: "Enter your Business Email",
          telephone: "Enter your Telephone",
          "agree_luciditi_policy[]": "",
        },
      });

      var contactvalid = $("#contact-form-contact-us-7").validate({
        rules: {
          first_name: {
            required: true,
          },
          last_name: {
            required: true,
          },
          business_name: {
            required: true,
          },
          business_email: {
            required: true,
            email: true,
          },
          telephone: {
            required: true,
          },
          WhatIsYourQuery: {
            required: true,
          },
          "agree_luciditi_policy[]": {
            "agree_luciditi_policy[]": true,
          },
        },
        messages: {
          first_name: "Enter your First Name",
          last_name: "Enter your Last Name",
          business_name: "Enter your Business Name",
          business_email: "Enter your Business Email",
          telephone: "Enter your Telephone",
          telephone: "Enter your Query",
          "agree_luciditi_policy[]": "",
        },
      });

      // var valid_business = $("#contact-form-business-starter-7").validate({
      // 	rules: {
      // 		first_name: {
      // 			required: true,
      // 		},
      // 		last_name: {
      // 			required: true,
      // 		},
      // 		email: {
      // 			required: true,
      // 			email: true,
      // 		},
      // 		telephone: {
      // 			required: true,
      // 		},
      // 		business_name: {
      // 			required: true,
      // 		},
      // 		"agree_luciditi_policy[]": {
      // 			"agree_luciditi_policy[]": true,
      // 		},
      // 	},
      // 	messages: {
      // 		first_name: "Enter your First Name",
      // 		last_name: "Enter your Last Name",
      // 		email: "Enter your Email",
      // 		telephone: "Enter your Telephone",
      // 		business_name: "Enter your Business Name",
      // 		"agree_luciditi_policy[]": "",
      // 	},
      // });

      jQuery.validator.addMethod(
        "agree_luciditi_policy[]",
        function (value, element) {
          if (!$(".agree_luciditi_policy_cls input").is(":checked")) {
            $(".agree_luciditi_policy_cls").addClass("error");
            $(".agree_luciditi_policy_cls input").val("false");
            return false;
          } else {
            $(".agree_luciditi_policy_cls").removeClass("error");
            $(".agree_luciditi_policy_cls input").val("true");
            return true;
          }
        }
      );

      $(".ls-next-btn-one").click(function () {
        $("#ls-step-one .ls-form-errors")
          .html("Please check and correct the errors!")
          .show();
        if (v.form()) {
          $(".ls-tab-panel").hide();
          $("#ls-step-one .ls-form-errors").html("").hide();
          $("#ls-step-two").show("slide", { direction: "right" }, 200);
        }
      });

      $(".ls-prev-btn-one").click(function () {
        $(".ls-tab-panel").hide();
        $("#ls-step-one").show("slide", { direction: "left" }, 200);
      });

      $(".show-features a").click(function () {
        $(this).parent().toggleClass("active-title");
        $(".mobile-content").toggleClass("active");
        $(this)
          .parents(".pricing-listing-row")
          .siblings()
          .find(".mobile-content")
          .removeClass("active");
        $(this)
          .parents(".pricing-listing-row")
          .siblings()
          .find(".show-features")
          .removeClass("active-title");
      });

      $("#about-you-btn-submit").click(function (event) {
        $(".ls-tab-panel-two  .ls-form-errors")
          .html("Please check and correct the errors!")
          .show();
        event.preventDefault();
        if (v.form()) {
          $(".ls-tab-panel-two .ls-form-errors").html("").hide();
          wpcf7.submit(document.querySelector("#contact-form-about-you-7"));
        }
      });
      $(
        "#contact-form-about-you-7 input,#contact-form-about-you-7 textarea,#contact-form-about-you-7 select,#contact-form-about-you-7 checkbox"
      ).on("change", function () {
        if (v.form()) {
          $(".ls-form-errors").html("").hide();
        }
      });

      $(".draggable_btn_img").on("click", function () {
        console.log("check click");
        var height = $(".site_default_banner").height();
        let final_height = height - 80;
        console.log(final_height);
        window.scrollTo({
          top: final_height,
          behavior: "smooth",
        });
      });

      $(".draggable_btn_img").click(function () {
        var height = $(".New-banner-block").height();
        let final_height = height - 80;
        window.scrollTo({
          top: final_height,
          behavior: "smooth",
        });
      });

      $(".site-faqs-listing-row h4").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).siblings(".text-area").slideUp(200);
        } else {
          $(".site-faqs-listing-row h4").removeClass("active");
          $(this).addClass("active");
          $(".text-area").slideUp(200);
          $(this).siblings(".text-area").slideDown(200);
        }
      });
      if ($(".site-faqs-listing-row").length > 0) {
        $(".site-faqs-listing-row h4:first")
          .addClass("active")
          .siblings(".text-area")
          .slideDown(200);
      }

      $(".custom-mega-menu").click(function (event) {
        var container = $(".menu-site_main_menu-container");
        if (
          !container.is(event.target) &&
          container.has(event.target).length === 0
        ) {
          $("header").removeClass("menu-active");
          $("body").removeClass("overflow-hidden");
        }
      });

      $(".close-menu-bar").click(function () {
        $("header").removeClass("menu-active");
        $("body").removeClass("overflow-hidden");
      });

      $("#request-demo-btn-submit").click(function (event) {
        event.preventDefault();
        if (valid.form()) {
          $("#contact-form-request-demo-7 .ls-form-errors").html("").hide();
          wpcf7.submit(document.querySelector("#contact-form-request-demo-7"));
        } else {
          $("#contact-form-request-demo-7 .ls-form-errors")
            .html("Please check and correct the errors!")
            .show();
        }
      });

      $("#contact-us-btn-submit").click(function (event) {
        event.preventDefault();
        if (contactvalid.form()) {
          $("#contact-form-contact-us-7 .ls-form-errors").html("").hide();
          wpcf7.submit(document.querySelector("#contact-form-contact-us-7"));
        } else {
          $("#contact-form-contact-us-7 .ls-form-errors")
            .html("Please check and correct the errors!")
            .show();
        }
      });

      $(
        "#contact-form-contact-us-7 input,#contact-form-contact-us-7 textarea,#contact-form-contact-us-7 checkbox"
      ).on("change", function () {
        if (contactvalid.form()) {
          $("#contact-form-contact-us-7 .ls-form-errors").html("").hide();
        }
      });

      // $('#contact-form-business-starter-7 .wpcf7-submit').on('click', function (event) {
      // //$(document).on('click',"#request-business-starter-btn-submit",function (event) {
      // 	alert(44554);
      // 	event.preventDefault();
      // 	if (valid_business.form()) {
      // 		$("#contact-form-business-starter-7 .ls-form-errors").html("").hide();
      // 		wpcf7.submit(
      // 			document.querySelector("#contact-form-business-starter-7")
      // 		);
      // 	} else {
      // 		$("#contact-form-business-starter-7 .ls-form-errors")
      // 			.html("Please check and correct the errors!")
      // 			.show();
      // 	}
      // });

      // $("#contact-form-business-starter-7 input").on("change", function () {
      // 	if (valid_business.form()) {
      // 		$(".ls-form-errors").html("").hide();
      // 	}
      // });

      $("#contact-form-request-demo-7 input").on("change", function () {
        if (valid.form()) {
          $(".ls-form-errors").html("").hide();
        }
      });
      scramble_words();
      AOS.init({ duration: 1200 });

      if (
        $(".pricing-listing-row-title-content").length > 0 &&
        $(".download-now-btn-block").length > 0
      ) {
        $(".download-now-btn-block")
          .parents(".pricing-listing-row-title-content")
          .addClass("active");
      }

      /*POPUP PRICING SECTION JS*/
      // if ($(".pricing-section").length) {
      // 	const totalOutput = document.querySelector(".final_plan_total_op"),
      // 		business_user = document.getElementById("business_user"),
      // 		acc_id_varifications = document.getElementById(
      // 			"acc_id_varifications"
      // 		),
      // 		data_requests_pm = document.getElementById("data_requests_pm"),
      // 		business_user_op = document.getElementById("business_user_op"),
      // 		acc_id_varifications_op = document.getElementById(
      // 			"acc_id_varifications_op"
      // 		),
      // 		data_requests_pm_op = document.getElementById("data_requests_pm_op"),
      // 		final_plan_total_op = document.getElementById("final_plan_total_op");
      // 	const firstPrice = [30, 60, 75];
      // 	const fulIDVerification = [82.5, 150, 225];
      // 	const dataRequestPrice = [84, 186, 193.2];
      // 	var valueC = [200, 500, 700];
      // 	var valueAB = [25, 50, 75];
      // 	window.addEventListener("change", function (e) {
      // 		let target = e.target;
      // 		business_user_op.innerHTML = valueAB[business_user.value];
      // 		acc_id_varifications_op.innerHTML =
      // 			valueAB[acc_id_varifications.value];
      // 		data_requests_pm_op.innerHTML = valueC[data_requests_pm.value];
      // 		const min = target.min;
      // 		const max = target.max;
      // 		const val = target.value;
      // 		target.style.backgroundSize =
      // 			((val - min) * 100) / (max - min) + "% 100%";
      // 		getValue();
      // 	});
      // 	function getValue() {
      // 		const finalOutput =
      // 			firstPrice[business_user.value] +
      // 			fulIDVerification[acc_id_varifications.value] +
      // 			dataRequestPrice[data_requests_pm.value];
      // 		final_plan_total_op.innerHTML = finalOutput;
      // 	}
      // 	window.onload = getValue();
      // }

      $(".close").click(function () {
        $(this).parents("#pricing-plan-popup").trigger("reset");
        $("#free-trial-req").prop("checked", false);
        $(this).parents("#pricing-plan-popup").hide();
        $(".free-trial").hide();
        $(".not-free-trial").show();
        $("input[type='range']").prop("disabled", false);
        $("input[type='range']")
          .parents(".pricing-section-row-content")
          .removeClass("disabled-slider");
      });

      jQuery("#signup_close").click(function () {
        jQuery("#weGot-yourDetailsNew-Popup").hide();
        jQuery("body").removeClass("overflow-hidden");
      });

      $(".faqs_questions_title").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this)
            .parents(".inner_custom_row")
            .siblings(".faqs_questions_answer")
            .removeClass("active");
        } else {
          $(".faqs_questions_title").removeClass("active");
          $(this).addClass("active");
          $(".faqs_questions_answer").removeClass("active");
          $(this)
            .parents(".inner_custom_row")
            .siblings(".faqs_questions_answer")
            .addClass("active");
        }
      });

      $(".request-demo-today").particleground({
        // dotColor: '#ff0000',
        // lineColor: '#ff0000'
        //dotColor: 'rgba(255,255,255,0.1)',
        dotColor: "rgba(51,125,255)",
        lineColor: "rgba(51,125,255)",
        particleRadius: 4,
        density: 4500,
        directionX: "top",
        directionY: "down",
      });
      $(".ageAssurance_tabs_title li").on("click", function () {
        var checkClass = $(this).attr("id");
        checkClass = checkClass.replace("_", "-");
        $(".listing-item").removeClass("active");
        $(this).addClass("active");
        $(this)
          .parents()
          .find(".ageAssurance_tabs_Contant_wrap_row")
          .removeClass("active-tab");
        $(this)
          .parents()
          .find("." + checkClass)
          .addClass("active-tab");
      });
      //buttons:
      //let playBtn = document.querySelector('.play-icon-slider');
      //let pauseBtn = document.querySelector('#homeVideo');
      //video:
      //let video = document.getElementById('homeVideo');

      //play function:
      // $('.play-icon-slider').click(function(){
      // 	if(video.pause){
      // 		video.play();
      // 		pauseBtn.style.display = 'inline-block';
      // 		playBtn.style.display = 'none';
      // 	}
      // });
      //pause function:
      // $('#homeVideo').click(function(){
      // 	if(video.play){
      // 		video.pause();
      // 		playBtn.style.display = 'inline-block';
      // 		pauseBtn.style.display = 'none';
      // 	}
      // });
    });
  }

  onResize() {
    window.addEventListener("resize", (event) => {});
  }
}

new Main();

$(function () {
  $.validator.addMethod(
    "noemail",
    function (value) {
      return /^([\w-.]+@(?!gmail\.com)(?!yahoo\.com)(?!hotmail\.com)(?!aol\.com)(?!hotmail\.co\.uk)(?!hotmail\.fr)(?!msn\.com)(?!yahoo\.fr)(?!wanadoo\.fr)(?!orange\.fr)(?!comcast\.net)(?!yahoo\.co\.uk)(?!yahoo\.com\.br)(?!yahoo\.co\.in)(?!yahoo\.co\.in)(?!live\.com)(?!rediffmail\.com)(?!free\.fr)(?!gmx\.de)(?!web\.de)(?!yandex\.ru)(?!yandex\.ru)(?!ymail\.com)(?!libero\.it)(?!outlook\.com)(?!uol\.com\.br)(?!bol\.com\.br)(?!mail\.ru)(?!cox\.net)(?!hotmail\.it)(?!sbcglobal\.net)(?!sfr\.fr)(?!live\.fr)(?!verizon\.net)(?!live\.co\.uk)(?!googlemail\.com)(?!yahoo\.es)(?!ig\.com\.br)(?!live\.nl)(?!bigpond\.com)(?!terra\.com\.br)(?!yahoo\.it)(?!neuf\.fr)(?!yahoo\.de)(?!alice\.it)(?!rocketmail\.com)(?!att\.net)(?!laposte\.net)(?!facebook\.com)(?!bellsouth\.net)(?!yahoo\.in)(?!hotmail\.es)(?!charter\.net)(?!yahoo\.ca)(?!yahoo\.com\.au)(?!rambler\.ru)(?!hotmail\.de)(?!tiscali\.it)(?!shaw\.ca)(?!yahoo\.co\.jp)(?!sky\.com)(?!earthlink\.net)(?!optonline\.net)(?!freenet\.de)(?!t-online\.de)(?!aliceadsl\.fr)(?!virgilio\.it)(?!home\.nl)(?!qq\.com)(?!telenet\.be)(?!me\.com)(?!yahoo\.com\.ar)(?!tiscali\.co\.uk)(?!yahoo\.com\.mx)(?!voila\.fr)(?!gmx\.net)(?!mail\.com)(?!planet\.nl)(?!tin\.it)(?!live\.it)(?!ntlworld\.com)(?!arcor\.de)(?!yahoo\.co\.id)(?!frontiernet\.net)(?!hetnet\.nl)(?!live\.com\.au)(?!yahoo\.com\.sg)(?!zonnet\.nl)(?!club-internet\.fr)(?!juno\.com)(?!optusnet\.com\.au)(?!blueyonder\.co\.uk)(?!bluewin\.ch)(?!skynet\.be)(?!sympatico\.ca)(?!windstream\.net)(?!mac\.com)(?!centurytel\.net)(?!chello\.nl)(?!live\.ca)(?!aim\.com)(?!icloud\.com)(?!bigpond\.net\.au)([\w-]+.)+[\w-]{2,4})?$/.test(
        value
      );
    },
    "Free email addresses are not allowed."
  );

  $.validator.addMethod(
    "websiteProtocol",
    function (value, element) {
      // Check if the value starts with "http://" or "https://"
      return (
        this.optional(element) ||
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/.test(
          value
        )
      );
    },
    "Please enter a valid website URL with http or https protocol."
  );

  var valid_business = $("#contact-form-business-starter-7").validate({
    rules: {
      first_name: {
        required: true,
      },
      last_name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
        noemail: true,
      },
      telephone: {
        required: true,
      },
      business_name: {
        required: true,
      },
      "agree_luciditi_policy[]": {
        "agree_luciditi_policy[]": true,
      },
    },
    messages: {
      first_name: "Enter your First Name",
      last_name: "Enter your Last Name",
      email: {
        required: "Enter your Email",
        noemail: "Please use your business email address.",
      },
      telephone: "Enter your Telephone",
      business_name: "Enter your Business Name",
      "agree_luciditi_policy[]": "",
    },
  });

  var signup_new_business = jQuery(
    "#pricing-signup-new-business-starter-7"
  ).validate({
    rules: {
      first_name: {
        required: true,
      },
      last_name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
        noemail: true,
      },
      telephone: {
        required: true,
      },
      business_name: {
        required: true,
      },
      business_website: {
        websiteProtocol: true,
        required: true,
      },
      business_paoi: {
        required: true,
      },
      business_noe: {
        required: true,
      },
      agree_luciditi_policy: {
        required: true,
      },
    },
    messages: {
      first_name: "Enter Your First Name",
      last_name: "Enter Your Last Name",
      email: {
        required: "Enter Your Email",
        noemail: "Please use your business email address.",
      },
      telephone: "Enter Your Telephone",
      business_name: "Enter Your Business Name",
      business_website: "Enter Your Business Web Site",
      business_paoi: "Enter Your Primary Area Of Interest",
      business_noe: "Enter Your Number Of Employees",
      agree_luciditi_policy: "Please agree to Privacy Policy",
    },
    errorPlacement: function (error, element) {
      if (element.attr("name") === "agree_luciditi_policy") {
        console.log(error);
        error.insertAfter(element.parent("span.form-control-wrap"));
      } else {
        console.log("no");
        error.insertAfter(element);
      }
    },
  });

  $("#contact-form-business-starter-7 #request-business-starter-btn-submit").on(
    "click",
    function (event) {
      event.preventDefault();
      if (valid_business.form()) {
        $("#contact-form-business-starter-7 .ls-form-errors").html("").hide();
        var formData = $("#contact-form-business-starter-7").serialize();
        jQuery.ajax({
          type: "POST",
          dataType: "JSON",
          url: my_ajax_object.ajax_url,
          beforeSend: function () {
            $(".loaderBtn").show();
          },
          data: {
            action: "enquerySubmissionForm",
            formData: formData,
          },
          success: function (response) {
            if (response.status == 200 && response.res == "OK") {
              var modal1 = document.getElementById("pricing-plan-popup");
              modal1.style.display = "none";
              var modal3 = document.getElementById("first-name-cf7");
              modal3.innerHTML = response.name;
              var modal2 = document.getElementById("weGot-yourDetails-Popup");
              modal2.style.display = "block";
            } else if (
              response.status == 400 &&
              response.res ==
                "The email address is already registered with another organisation account"
            ) {
              $("#email-already-register-Popup .close").hide();
              var modal1 = document.getElementById("pricing-plan-popup");
              modal1.style.display = "none";
              var modal2 = document.getElementById(
                "email-already-register-Popup"
              );
              var modal4 = document
                .querySelector("#email-already-register-Popup")
                .querySelector("p");
              var modal3 = document.getElementById("email_already_btn_main");

              modal4.innerHTML = response.res;
              modal2.style.display = "block";
              modal3.style.display = "block";
            } else {
              // var modal1 = document.getElementById("pricing-plan-popup");
              // modal1.style.display = "none";
              var modal2 = document.getElementById(
                "email-already-register-Popup"
              );
              var modal3 = document.getElementById("email_already_btn_main");
              var modal4 = document
                .querySelector("#email-already-register-Popup")
                .querySelector("p");
              $("#email-already-register-Popup .close").show();
              modal4.innerHTML = response.res;
              modal2.style.display = "block";
              modal3.style.display = "none";
            }
          },
          complete: function () {
            $(".loaderBtn").hide();
          },
        });
      } else {
        $("#contact-form-business-starter-7 .ls-form-errors")
          .html("Please check and correct the errors!")
          .show();
      }
    }
  );

  $("#contact-form-business-starter-7 input").on("change", function () {
    if (valid_business.form()) {
      $(".ls-form-errors").html("").hide();
    }
  });

  jQuery(
    "#pricing-signup-new-business-starter-7 #request-business-starter-btn-submit"
  ).on("click", function (event) {
    event.preventDefault();
    if (signup_new_business.form()) {
      jQuery("#pricing-signup-new-business-starter-7 .ls-form-errors")
        .html("")
        .hide();
      var formData = jQuery(
        "#pricing-signup-new-business-starter-7"
      ).serialize();
      jQuery.ajax({
        type: "POST",
        dataType: "JSON",
        url: my_ajax_object.ajax_url,
        beforeSend: function () {
          jQuery(".loaderBtn").show();
        },
        data: {
          action: "enquerySubmissionForm",
          formData: formData,
        },
        success: function (response) {
          if (response.status == 200 && response.res == "OK") {
            var modal1 = document.getElementById("pricing-signup-new-popup");
            modal1.style.display = "none";
            var modal3 = document.getElementById("first-name-cf7-new");
            modal3.innerHTML = response.name;
            var modal2 = document.getElementById("weGot-yourDetailsNew-Popup");
            modal2.style.display = "block";
          } else if (
            response.status == 400 &&
            response.res ==
              "The email address is already registered with another organisation account"
          ) {
            jQuery("#email-already-register-Popup .close").hide();
            var modal1 = document.getElementById("pricing-signup-new-popup");
            modal1.style.display = "none";
            var modal2 = document.getElementById(
              "email-already-register-Popup"
            );
            var modal4 = document
              .querySelector("#email-already-register-Popup")
              .querySelector("p");
            var modal3 = document.getElementById("email_already_btn_main");

            modal4.innerHTML = response.res;
            modal2.style.display = "block";
            modal3.style.display = "block";
          } else {
            // var modal1 = document.getElementById("pricing-plan-popup");
            // modal1.style.display = "none";
            var modal2 = document.getElementById(
              "email-already-register-Popup"
            );
            var modal3 = document.getElementById("email_already_btn_main");
            var modal4 = document
              .querySelector("#email-already-register-Popup")
              .querySelector("p");
            jQuery("#email-already-register-Popup .close").show();
            modal4.innerHTML = response.res;
            modal2.style.display = "block";
            modal3.style.display = "none";
          }
        },
        complete: function () {
          jQuery(".loaderBtn").hide();
        },
      });
    } else {
      jQuery("#pricing-signup-new-business-starter-7 .ls-form-errors")
        .html("Please check and correct the errors!")
        .show();
    }
  });

  jQuery("#pricing-signup-new-business-starter-7 input").on(
    "change",
    function () {
      if (valid_business.form()) {
        jQuery(".ls-form-errors").html("").hide();
      }
    }
  );


  jQuery(".cancel-feature").on("click", function(e) {
      e.preventDefault();
      var fid = jQuery(this).attr("data-cancel");
      if(fid){
          jQuery("#"+fid).css("display", "none");
          var vData = jQuery("#"+fid).find("#vimeo-video-container-"+fid);
          if(vData){
            vData.html("");
          }
      }
  });

  $("#email_already_reg_popup_btn").on("click", function (event) {
    event.preventDefault();
    if (valid_business.form()) {
      $("#contact-form-business-starter-7 .ls-form-errors").html("").hide();
      var formData = $("#contact-form-business-starter-7").serialize();
      jQuery.ajax({
        type: "POST",
        dataType: "JSON",
        url: my_ajax_object.ajax_url,
        beforeSend: function () {
          $("#loaderBtn2").show();
        },
        data: {
          action: "enquerySubmissionForm",
          formData: formData,
          skipRegisteredEmailCheck: true,
        },
        success: function (response) {
          if (response.status == 200 && response.res == "OK") {
            var modal1 = document.getElementById(
              "email-already-register-Popup"
            );
            modal1.style.display = "none";
            var modal3 = document.getElementById("first-name-cf7");
            modal3.innerHTML = response.name;
            var modal2 = document.getElementById("weGot-yourDetails-Popup");
            modal2.style.display = "block";
          } else {
            // var modal1 = document.getElementById("pricing-plan-popup");
            // modal1.style.display = "none";
            var modal2 = document.getElementById(
              "email-already-register-Popup"
            );
            var modal3 = document.getElementById("email_already_btn_main");
            var modal4 = document
              .querySelector("#email-already-register-Popup")
              .querySelector("p");
            $("#email-already-register-Popup .close").show();
            modal4.innerHTML = response.res;
            modal2.style.display = "block";
            modal3.style.display = "none";
          }
        },
        complete: function () {
          $("#loaderBtn2").hide();
        },
      });
    } else {
      $("#contact-form-business-starter-7 .ls-form-errors")
        .html("Please check and correct the errors!")
        .show();
    }
  });

  $(".social-details-block .share-icon").on("click", function () {
    $(".social-details-block .social-popup").toggleClass("active");
  });
  $(".email-already-register-Popup .close").on("click", function () {
    $(".email-already-register-Popup").hide();
  });

  // business popup open on more button
  $("a.more-infoBtn").on("click", function () {
    $(this).parent().parent().find(".popupContent").addClass("active");
  });
  $(".popupContent .close-popup_Btn").on("click", function () {
    $(this).parent().removeClass("active");
  });

  $(document).keyup(function (e) {
    if (e.which == 27) {
      $(".modal").hide();
      $("body").removeClass("overflow-hidden");
    }
  });

});

function scramble_words() {
  if ($(".scramble_words").length > 0 || $(".scramble_words2").length > 0) {
    class TextScramble {
      constructor(el) {
        this.el = el;
        this.chars = "!<>-_\\/[]{}—=+*^?#_";
        this.update = this.update.bind(this);
      }
      setText(newText) {
        const oldText = this.el.innerText;
        const length = Math.max(oldText.length, newText.length);
        const promise = new Promise((resolve) => (this.resolve = resolve));
        this.queue = [];
        for (let i = 0; i < length; i++) {
          const from = oldText[i] || "";
          const to = newText[i] || "";
          const start = Math.floor(Math.random() * 40);
          const end = start + Math.floor(Math.random() * 40);
          this.queue.push({ from, to, start, end });
        }
        cancelAnimationFrame(this.frameRequest);
        this.frame = 10;
        this.update();
        return promise;
      }
      update() {
        let output = "";
        let complete = 0;
        for (let i = 0, n = this.queue.length; i < n; i++) {
          let { from, to, start, end, char } = this.queue[i];
          if (this.frame >= end) {
            complete++;
            output += to;
          } else if (this.frame >= start) {
            if (!char || Math.random() < 0.1) {
              char = this.randomChar();
              this.queue[i].char = char;
            }
            output += `<span class="scramble">${char}</span>`;
            $(".scramble").animate(2000, "linear");
          } else {
            output += from;
          }
        }
        this.el.innerHTML = output;
        if (complete === this.queue.length) {
          this.resolve();
        } else {
          this.frameRequest = requestAnimationFrame(this.update);
          this.frame++;
        }
      }
      randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)];
      }
    }
    if ($(".scramble_words").length > 0) {
      const phrases = ["Employees", "Tenants", "Customers", "Members"];
      const el = document.querySelector(".scramble_words");
      const fx = new TextScramble(el);

      let counter = 0;
      const next = () => {
        fx.setText(phrases[counter]).then(() => {
          setTimeout(next, 1000);
        });
        counter = (counter + 1) % phrases.length;
      };
      next();
    }
    if ($(".scramble_words2").length > 0) {
      const phrases2 = ["Users", "Members", "Employees", "Collegues"];

      const el2 = document.querySelector(".scramble_words2");
      const fx2 = new TextScramble(el2);

      let counter2 = 0;
      const next2 = () => {
        fx2.setText(phrases2[counter2]).then(() => {
          setTimeout(next2, 1000);
        });
        counter2 = (counter2 + 1) % phrases2.length;
      };
      next2();
    }
    if ($(".scramble_words3").length > 0) {
      const phrases3 = ["Passwords", "Phishing", "OTPs"];

      const el3 = document.querySelector(".scramble_words3");
      const fx3 = new TextScramble(el3);

      let counter3 = 0;
      const next3 = () => {
        fx3.setText(phrases3[counter3]).then(() => {
          setTimeout(next3, 1000);
        });
        counter3 = (counter3 + 1) % phrases3.length;
      };
      next3();
    }
    if ($(".scramble_words4").length > 0) {
      const phrases4 = ["Customers", "Users", "Members", "Players"];

      const el4 = document.querySelector(".scramble_words4");
      const fx4 = new TextScramble(el4);

      let counter4 = 0;
      const next4 = () => {
        fx4.setText(phrases4[counter4]).then(() => {
          setTimeout(next4, 1000);
        });
        counter4 = (counter4 + 1) % phrases4.length;
      };
      next4();
    }

    if ($(".scramble_words5").length > 0) {
      const phrases5 = ["Customers", "Users", "Members", "Players"];

      const el5 = document.querySelector(".scramble_words5");
      const fx5 = new TextScramble(el5);

      let counter5 = 0;
      const next5 = () => {
        fx5.setText(phrases5[counter5]).then(() => {
          setTimeout(next5, 1000);
        });
        counter5 = (counter5 + 1) % phrases5.length;
      };
      next5();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/index.js